<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g :clip-path="`url(#${clipPathId})`" data-figma-skip-parse="true">
      <g transform="matrix(0.0119612 1.42407e-06 0 -0.0119986 11.9612 12)">
        <foreignObject x="-1083.6" y="-1083.6" width="2167.21" height="2167.21">
          <div
            xmlns="http://www.w3.org/1999/xhtml"
            style="
              width: 100%;
              height: 100%;
              background: conic-gradient(
                from 90deg,
                rgba(99, 36, 235, 1) 0deg,
                rgba(241, 82, 158, 1) 136.8deg,
                rgba(255, 255, 255, 0) 360deg
              );
              opacity: 1;
            "
          ></div>
        </foreignObject>
      </g>
    </g>
    <path
      d="M11.9612 23.9986C18.5672 23.9994 23.9224 18.6281 23.9224 12.0014C23.9224 5.37479 18.5672 0.00221056 11.9612 0.00142407C5.35522 0.000637576 0 5.37195 0 11.9986C0 18.6252 5.35522 23.9978 11.9612 23.9986ZM11.9612 3.98878C16.3719 3.9893 19.9475 7.57647 19.9475 12.001C19.9475 16.4254 16.3719 20.0118 11.9612 20.0112C7.55052 20.0107 3.97494 16.4235 3.97494 11.999C3.97494 7.57457 7.55052 3.98825 11.9612 3.98878Z"
      data-figma-gradient-fill='{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.38823530077934265,"g":0.14117647707462311,"b":0.92156863212585449,"a":1.0},"position":0.0},{"color":{"r":0.94509804248809814,"g":0.32156863808631897,"b":0.61960786581039429,"a":1.0},"position":0.37999999523162842},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":0.0},"position":1.0}],"stopsVar":[{"color":{"r":0.38823530077934265,"g":0.14117647707462311,"b":0.92156863212585449,"a":1.0},"position":0.0},{"color":{"r":0.94509804248809814,"g":0.32156863808631897,"b":0.61960786581039429,"a":1.0},"position":0.37999999523162842},{"color":{"r":1.0,"g":1.0,"b":1.0,"a":0.0},"position":1.0}],"transform":{"m00":23.922433853149414,"m01":-3.4911021962831176e-15,"m02":3.4911021962831176e-15,"m10":0.0028481325134634972,"m11":-23.997152328491211,"m12":23.997152328491211},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
    />
    <path
      d="M23.9953 11.9069C23.9979 10.798 23.1049 9.89908 22.0007 9.89908C20.8966 9.89908 19.9994 10.798 19.9968 11.9069C19.9943 13.0158 20.8873 13.9148 21.9914 13.9148C23.0956 13.9148 23.9927 13.0158 23.9953 11.9069Z"
      fill="#6324EB"
    />
    <defs>
      <clipPath :id="clipPathId">
        <path
          d="M11.9612 23.9986C18.5672 23.9994 23.9224 18.6281 23.9224 12.0014C23.9224 5.37479 18.5672 0.00221056 11.9612 0.00142407C5.35522 0.000637576 0 5.37195 0 11.9986C0 18.6252 5.35522 23.9978 11.9612 23.9986ZM11.9612 3.98878C16.3719 3.9893 19.9475 7.57647 19.9475 12.001C19.9475 16.4254 16.3719 20.0118 11.9612 20.0112C7.55052 20.0107 3.97494 16.4235 3.97494 11.999C3.97494 7.57457 7.55052 3.98825 11.9612 3.98878Z"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup lang="ts">
  import { useId } from 'vue';

  defineOptions({
    name: 'CharacterLoadingIcon'
  });

  const clipPathId = `character-loading-${useId().replace(/:/g, '')}`;
</script>
